import { render, staticRenderFns } from "./fuseChooseGoods.vue?vue&type=template&id=ce624456&scoped=true"
import script from "./fuseChooseGoods.vue?vue&type=script&lang=js"
export * from "./fuseChooseGoods.vue?vue&type=script&lang=js"
import style0 from "./fuseChooseGoods.vue?vue&type=style&index=0&id=ce624456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce624456",
  null
  
)

export default component.exports